app.service('statusDelivery',function(modal, loading, message){

	function loadSuccess(html){
		modal.generate({
			id:'status-details-modal',
			content:html
		});
	}
	function load(status){
		loading.start();
		$.ajax({
			url:'/status-details.ltr',
			data:{
				status_code:status
			},
			success:function(html){
				loadSuccess(html);
			},
			complete:function(){
				loading.stop();
			}
		});
	}

	function setEvents(){
		$('body').on('click', '.js-phone-delivery', function() {
			loading.start();

			$.ajax({
				url:'/partner-subscription-message-alert.ltr',
				data:{
					name: 'after-sale-contract-description',
					supplierId:$(this).data('supplier')
				},
				success:function(html){
					loading.stop();
					modal.generate({
						id: 'partner-delivery-modal',
						modifier: 'remodal-full-width',
						content:html
					});
				},
				error:function(){
					loading.stop();
					modal.alert('Błąd pobierania opisu usługi');
				}
			});
		})
		$('body').on('click', '.js-status-delivery', function() {
			load($(this).data('status'), $(this).data('product'));
		});
	}
	function setElements(){

	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init:init
	};
});
